import { request } from '../index'

// Transações

export function getTransactions(params={}) { 
    return request({url: "financial/transactions/", params})
}
export function CreateTransaction(data) {
    return request({ url: "financial/transactions/", method: "POST", data });
}
export function UpdateTransaction(id, data) {
    return request({ url: `financial/transactions/${id}/`, method: "PUT", data });
}
export function ConfirmTransaction(id, data) {
    return request({ url: `financial/transactions/${id}/confirm/`, method: "PUT", data });
}
export function CancelTransaction(id) {
    return request({ url: `financial/transactions/${id}/cancel/`, method: "DELETE"});
}
export function filterTransaction(params={}) {
    return request({ url: "financial/transactions/", params })
}

export function totalTransaction(params={}) {
    return request({ url: "financial/transactions/totals/", params })
}
export function totalMonthlyTransaction(params={}) {
    return request({ url: "financial/transactions/total/period/", params })
}
// Categoria de Pagamento

export function createPaymentCategory(name){
    return request({ url: "financial/category/", method: "POST", data: {name} });
}
export function getPaymentCategory(params={}){
    return request({ url: "financial/category/", params});
}
export function RenameCategory(id, name){
    return request({ url: `financial/category/${id}/`, method: "PUT", data: {name}});
}
export function ToogleActivationCategory(id){
    return request({ url: `financial/category/${id}/activate/`, method: "PUT"});
}

// Centro de Custo

export function getPaymentCostCenter(params={}){
    return request({url: "financial/cost-center/", params})
}
export function createPaymentCostCenter(name){
    return request({url: "financial/cost-center/", method: "POST", data: {name} })
}
export function renameCostCenter(id, name){
    return request({ url: `financial/cost-center/${id}/`, method: "PUT", data: {name}});
}
export function ToogleActivationCostCenter(id){
    return request({ url: `financial/cost-center/${id}/activate/`, method: "PUT"});
}
export function startTrial(){
    return request({ url: "branch-plans/start-financial-start-trial/", method: "PUT"});
}

// GPT VISION
export function readBase64Image(data){
    /*
        data : {
            img64: ata:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2w...
        }
    */
    return request({ url: "financial/transactions/gpt-vision/read/", method: "POST", data});
}

// END GPT VISION


// WEBPACK FOOTER //
// ./src/api/financial/index.js